import { colors, fontSizes } from '_/config/theme';

import { useVisit } from '_/hooks/VisitContext';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View, TouchableOpacity } from 'react-native';

import ModalView from '../Modal';
import Text from '../Text';
import { VisitsModel } from '@w3lcome/types';
import { useCentralizedValuesFallback } from '_/hooks/useCentralizedValuesFallback';

interface MeetingDetailsModalProps {
  hideModal(): void;
  handleConfirm(visit: any): void;
  isModalVisible: boolean;
  visits: VisitsModel[];
}

const SelectVisitModal: React.FC<MeetingDetailsModalProps> = ({
  hideModal,
  handleConfirm,
  isModalVisible,
  visits,
}) => {
  const { t, i18n } = useTranslation();

  const { selectedOrFallbackVisitFlowTypes } = useCentralizedValuesFallback();

  return (
    <ModalView isVisible={isModalVisible}>
      <Text size={fontSizes.xl} center fontType="bold">
        {t('Selecione o credenciamento que deseja realizar')}
      </Text>
      <View style={styles.content}>
        {visits.map((v) => (
          <TouchableOpacity key={v.id} style={styles.col} onPress={() => handleConfirm(v)}>
            <Text fontType="semibold" style={styles.textStrong}>
              {v.meeting?.title}:
            </Text>
            <Text style={styles.text}>
              {selectedOrFallbackVisitFlowTypes.find((vft) => vft.id === v.visitFlowTypeId)?.name}
            </Text>
            {/* <View style={styles.col}>
              <Text fontType="semibold" style={styles.textStrong}>
                {t('Company')}:
              </Text>
              <Text style={styles.text}>{v.companyname}</Text>
            </View> */}
          </TouchableOpacity>
        ))}
      </View>
      <View style={styles.buttonContanier}>
        <TouchableOpacity style={styles.button} onPress={() => hideModal()}>
          <Text fontType="semibold" size={24} color={colors.dark3}>
            {t('Cancel')}
          </Text>
        </TouchableOpacity>
      </View>
    </ModalView>
  );
};

export default SelectVisitModal;

const styles = StyleSheet.create({
  content: {
    width: '100%',
    paddingBottom: 24,
    paddingHorizontal: 24,
    borderBottomWidth: 1,
    borderBottomColor: colors.light3,
    overflow: 'hidden',
  },
  col: {
    width: '100%',
    paddingVertical: 20,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: colors.light3,
    borderRadius: 8,
    marginTop: 12,
  },
  infoButtonTag: {
    marginTop: 4,
    marginLeft: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: colors.light3,
  },
  textStrong: {
    fontSize: fontSizes.lg2,
  },
  text: {
    fontSize: fontSizes.xl,
    marginLeft: 8,
  },
  buttonContanier: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginTop: 12,
    width: '100%',
  },
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 12,
  },
});
